/**
 * Utility function to handle file downloads from blob data
 * @param {Blob|File} fileData - The file data to download
 * @param {string} fileName - The name of the file to be downloaded
 * @param {string} [fileType='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'] - MIME type of the file
 */
export const downloadFile = (fileData, fileName, fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') => {
  try {
    // Create blob if not already a blob
    const blob = fileData instanceof Blob 
      ? fileData 
      : new Blob([fileData], { type: fileType });

    // Create object URL
    const url = window.URL.createObjectURL(blob);
    
    // Create temporary anchor element
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    
    // Trigger download
    document.body.appendChild(a);
    a.click();
    
    // Cleanup
    setTimeout(() => {
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }, 0);
  } catch (error) {
    console.error('Error downloading file:', error);
    throw error;
  }
};

/**
 * Generates a timestamped filename with the given prefix and extension
 * @param {string} prefix - The prefix for the filename
 * @param {string} [extension='xlsx'] - The file extension without the dot
 * @returns {string} Formatted filename with timestamp
 */
export const generateTimestampedFilename = (prefix, extension = 'xlsx') => {
  const date = new Date().toISOString().split('T')[0];
  return `${prefix}-${date}.${extension}`;
};
